import { Component }           from '@angular/core';
import { NavController }       from 'ionic-angular';
import { LoadingController }   from 'ionic-angular';
import { ModalController }     from 'ionic-angular';
import { dmHotel }             from '../sign-in/xv-hotel';
import { TaskReportViewModel } from './xv-task-report';
import { MLText, mlBroker }    from '../../services/MLText';
import { AppDataBroker }       from '../../services/AppData';
import { SignInPage }          from '../sign-in/sign-in';
import { dmLoading }           from '../loading/loading';

import { CalendarModal, CalendarModalOptions, CalendarResult } from "ion2-calendar";

@Component({
     selector:    'page-task-report'
    ,templateUrl: 'task-report.html'
})
export class TaskReportPage {
    TaskReport:   TaskReportViewModel;
    NewLoading:   (pMessage: string) => dmLoading;
    BackToSignIn: ()                 => void;
    ShowCalendar: (
         pToday:  Date
        ,pStart:  Date
        ,pEnd:    Date
        ,pTitle:  string
        ,pLangID: number
        ,pAction: (pFrom: Date, pTo: Date) => void
    ) => void;

    constructor(
         public navCtrl:       NavController
        ,public loadingCtrl:   LoadingController
        ,public modalCtrl:     ModalController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel       = appDataBroker.GetAppData() as dmHotel;

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.ShowCalendar = (
             pToday:  Date
            ,pStart:  Date
            ,pEnd:    Date
            ,pTitle:  string
            ,pLangID: number
            ,pAction: (pFrom: Date, pTo: Date) => void
        ) => {
            let firstDay: Date = new Date();

            firstDay.setDate(pToday.getDate() - 100);

            if (pEnd <= pStart) {
                pEnd = new Date(pStart);

                pEnd.setDate(pEnd.getDate() + 1);
            }

            const options: CalendarModalOptions = {
                 pickMode:         'range'
                ,title:            pTitle
                ,from:             firstDay
                ,defaultDateRange: { from: pStart, to: pEnd }
                ,defaultScrollTo:  pStart
                ,color:            'danger'
            };

            let calendar = this.modalCtrl.create(CalendarModal ,{
                options: options
            });

            calendar.onDidDismiss((
                 date: { from: CalendarResult; to: CalendarResult }
                ,type: string
            ) => {
                if (
                    (type == 'cancel')
                ||  (type == 'backdrop')
                ||  (!(date.from.dateObj && date.to.dateObj))
                ) { return; }

                pAction(date.from.dateObj, date.to.dateObj);
            });

            calendar.present();
        };

        this.TaskReport   = new TaskReportViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.NewLoading
            ,this.ShowCalendar
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/task-report/task-report.ts